import React, { FC, useEffect, useState } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import MasonryWrapper from '../../../../../Common/MasonryWrapper/MasonryWrapper';
import { IPicture } from '../../../../../../interfaces/professional/Professional';
import GalleryPictureItem from '../../../../../Common/GalleryPictureItem/GalleryPictureItem';
import * as classes from './PicturesSection.module.scss';
import { VISIBLE_PICTURES_LIMIT } from '../../../../../../constants/constants';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import LightBoxWrapper from '../../../Components/LightBoxWrapper/LightBoxWrapper';
import { PicturesSectionProps } from '../../../../../Sections/Gallery/PicturesSection/PicturesSection';
import DefaultButton from '../../../Components/DefaultButton/DefaultButton';

const PicturesSection: FC<PicturesSectionProps> = ({ pictures }) => {
  const { t } = useTranslation();
  const picturesMapper = (item: IPicture, index: number) => (
    <div onClick={() => pictureClickHandler(index)} key={index}>
      <GalleryPictureItem image={item.url} description={item.description} />
    </div>
  );
  const [visiblePictures, setVisiblePictures] = useState<Array<IPicture>>([]);
  const [isLoadMoreVisible, setIsLoadMoreVisible] = useState(false);
  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);
  const [currentPictureIndex, setCurrentPictureIndex] = useState(0);

  useEffect(() => {
    if (pictures.length > VISIBLE_PICTURES_LIMIT) {
      setVisiblePictures(pictures?.slice(0, VISIBLE_PICTURES_LIMIT));
      setIsLoadMoreVisible(true);
      return;
    }
    setVisiblePictures(pictures);
  }, [pictures, pictures.length]);

  const loadMoreHandler = () => {
    setVisiblePictures(pictures);
    setIsLoadMoreVisible(false);
  };

  const pictureClickHandler = (index: number) => {
    setIsLightBoxOpen(true);
    setCurrentPictureIndex(index);
  };

  return (
    <Section number={'01'} label={t('gallery.pictures.sectionTitle')}>
      <Container className={classes.wrapper}>
        <MasonryWrapper>{visiblePictures.map(picturesMapper)}</MasonryWrapper>
        {isLoadMoreVisible && (
          <div className={classes.buttonWrapper}>
            <DefaultButton onClick={loadMoreHandler}>{t('gallery.pictures.loadMoreButtonText')}</DefaultButton>
          </div>
        )}
        <LightBoxWrapper
          isOpen={isLightBoxOpen}
          pictures={pictures}
          onClose={() => setIsLightBoxOpen(false)}
          photoIndex={currentPictureIndex}
          onMove={setCurrentPictureIndex}
        />
      </Container>
    </Section>
  );
};

export default PicturesSection;
